import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Landing from "@/pages/Landing";
import Explore from "@/pages/Explore";
import Experts from "@/pages/Experts";
import Itinerary from "@/pages/Itinerary";
import Trip from "@/pages/Trip";
import Activities from "@/pages/Activities";
import Budget from "@/pages/Budget";
import RealityCheck from "@/pages/RealityCheck";
import Creator from "@/pages/Creator";
import Visa from "@/pages/Visa";
import Forex from "@/pages/Forex";
import Phrasebook from "@/pages/Phrasebook";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminAutoBlog from "@/pages/AdminAutoBlog";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import MyTrips from "@/pages/MyTrips";
import MyNotes from "@/pages/MyNotes";
import AuthCallback from "@/pages/AuthCallback";
import Consultation from "@/pages/Consultation";
import { initAnalytics } from "@/lib/analytics";
import { RouteTracker } from "@/components/RouteTracker";
import { MobileTabBar } from "@/components/MobileTabBar";
import { FirstVisitNudge } from "@/components/FirstVisitNudge";
import { AuthProvider } from "@/lib/AuthContext";

function AppRoutes() {
  const location = useLocation();
  // Synchronously intercept the OAuth callback (Emergent appends #session_id=...
  // to whatever return URL we sent). This runs BEFORE any route loads so we
  // never race the AuthProvider's /me check.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/explore" element={<Explore />} />
      <Route path="/explore/:country" element={<Explore />} />
      <Route path="/experts" element={<Experts />} />
      <Route path="/experts/:country" element={<Experts />} />
      <Route path="/itinerary" element={<Itinerary />} />
      <Route path="/itinerary/:country" element={<Itinerary />} />
      <Route path="/trip/:id" element={<Trip />} />
      <Route path="/activities" element={<Activities />} />
      <Route path="/activities/:country" element={<Activities />} />
      <Route path="/budget" element={<Budget />} />
      <Route path="/reality-check" element={<RealityCheck />} />
      <Route path="/reality-check/:country" element={<RealityCheck />} />
      <Route path="/creator" element={<Creator />} />
      <Route path="/visa" element={<Visa />} />
      <Route path="/forex" element={<Forex />} />
      <Route path="/phrasebook" element={<Phrasebook />} />
      <Route path="/phrasebook/:country" element={<Phrasebook />} />
      <Route path="/me/trips" element={<MyTrips />} />
      <Route path="/me/notes" element={<MyNotes />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/admin/autoblog" element={<AdminAutoBlog />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/consultation" element={<Consultation />} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    initAnalytics();
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <RouteTracker />
          <AppRoutes />
          <MobileTabBar />
          <FirstVisitNudge />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
